app.controller('ScheduleEventInfoController', ['$scope', '$http', '$timeout', '$translate', function ($scope, $http, $timeout, $translate) {

	$scope.schedule = schedule;
	$scope.client = client;
	$scope.attending = attending;

	var scheduleDate = new Date(schedule.Date);
	var dateBeforeCancel = new Date(schedule.Date);
	dateBeforeCancel.setHours(dateBeforeCancel.getHours() - settings.HoursBeforeCanceling);
	var today = new Date();

	if (scheduleDate > today) {
		$scope.canCancel = true;
	}

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}

	// Get Areas
	$scope.getAreas = function () {
		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetAreas?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			var x = findElement(data, "AreaID", $scope.schedule.AreaID);
			if(x){
				$scope.areaName = x['Name'];
			}

		}).error(function () {

		});
	}

	$scope.getAreas();

	$scope.leaveEvent = function () {
		var now = new Date();

		if (now < dateBeforeCancel) {
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: $scope.schedule.ID,
				ClientID: $scope.client.ClientID,
				Language: lang
			}

			$http({
				method: 'POST',
				url: '/private/leaveEvent',
				data: dataObject
			}).success(function (data) {
				if (data == true || data == 'True') {
					$('.event-box .actions').addClass('show-success');
				}
			}).error(function () {

			});
		} else {
			$('.event-box .actions').addClass('show-error');
		}
	}

}]);